import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getExamsAvailableTimes} from '../../services/getExamsAvailableTimes';
import {UseGetExamsAvailableTimesQueryProps} from './types';

export function useGetExamsAvailableTimesQuery({
	params,
	enabled,
}: UseGetExamsAvailableTimesQueryProps) {
	return useQuery({
		queryKey: [QUERY_KEYS.EXAMS_AVAILABLE_TIMES, params],
		queryFn: ({signal}) => getExamsAvailableTimes({signal, ...params}),
		retry: 1,
		enabled,
		staleTime: 0,
		gcTime: 0,
	});
}
